import api from '@/api/api-endpoints'
import { createAsyncMutation, doAsyncGet } from '@/api/async-util'

const types = {
    GET_ARTICLES: createAsyncMutation('GET_ARTICLES'),
}

const article = {
    state: {},
    mutations: {},
    actions: {
        // GET
        getArticles(store, top) {
            let url = api.article
            if (top) {
                url += '?top=' + top
            }
            return doAsyncGet(store, { url, mutationTypes: types.GET_ARTICLES })
        },

        // POST

        // PUT

        // DELETE
    },
    getters: {},
    types: types
}

export default article
